/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { scoreStem } from "@examspark/score";
import { StemNumberLinePlot } from "@examspark/types";

import Mark from "../../common/Mark";
import QuestionContext from "../../QuestionContext";
import NumberLineGraph from "../common/graph/number-line/NumberLineGraph";
import NumberLineToolbar from "../common/graph/number-line/NumberLineToolbar";
import Prompt from "../shared/Prompt";

const Wrapper = styled.div`
  max-width: 55rem;
`;
const GraphWrapper = styled.div`
  background-color: #f7f7f7;
  display: flex;
  justify-content: center;
  padding: 1rem;
`;

interface MarkProps {
  mark?: "correct" | "incorrect";
}

const Styled = styled.div<MarkProps>`
  /* display: flex; */
  position: relative;
  padding: 1rem 1rem;
  border-top: solid 3px transparent;
  background-color: #f7f7f7;

  ${(props) => {
    if (props.mark === "correct") {
      return `
      background-color: #e4f3e4;
      border-top: solid 3px #9cb39c;
      `;
    }
    if (props.mark === "incorrect") {
      return `
      background-color: #f3e2e2;
      border-top: solid 3px #b32e2b;
      `;
    }
  }}

  .markup {
    position: absolute;
    top: -11px;
    right: -8px;
  }
`;
export interface ItemNumberLineProps {
  data: StemNumberLinePlot;
}

const NumberLine: React.FC<React.PropsWithChildren<ItemNumberLineProps>> = (
  props,
) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);
  const [mode, setMode] = useState<string>();

  // Reveal Key
  useEffect(() => {
    if (!player.response) return;
    if (player.revealKey) {
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            shapes: props.data.scoring?.shapes,
          },
        },
      });
    }
  }, [player.revealKey]);

  // Mark the response
  let mark: "incorrect" | "correct" | undefined;
  if (player.scoreResponses && player.response?.[props.data.id]?.shapes) {
    const score = scoreStem(props.data, player.response[props.data.id]);

    if (score.actual && score.actual === score.max) {
      mark = "correct";
    } else {
      mark = "incorrect";
    }
  }

  return (
    <>
      <Prompt data={props.data.content.prompt} />
      <Wrapper>
        <NumberLineToolbar mode={mode} onChange={(mode) => setMode(mode)} />
        <Styled mark={mark}>
          {mark && <Mark type={mark} />}
          <GraphWrapper>
            <NumberLineGraph
              width={500}
              height={100}
              x={props.data.config.numberLine}
              y={{
                min: -3.5,
                max: 3.5,
                tickDistance: 0.5,
                minorTicks: 0,
              }}
              mode={mode}
              shapes={player.response?.[props.data.id]?.shapes || []}
              onChange={(shapes) => {
                setMode(undefined);
                dispatchPlayer({
                  type: "RESPONSE",
                  data: {
                    id: props.data.id,
                    response: {
                      shapes: shapes,
                    },
                  },
                });
              }}
            />
          </GraphWrapper>
        </Styled>
      </Wrapper>
    </>
  );
};

export default NumberLine;
